import { Configuration, LogLevel } from "@azure/msal-browser";

const currentOrigin = window.location.origin;
let clientId = "";
let tenantId = "";
let redirectUri = currentOrigin; // default



let baseDomain = "";

// Handle environment automatically
if (currentOrigin.includes("localhost")) {
  // Local Environment
  baseDomain = "http://localhost:3000";
  clientId = "de4a41ef-5c38-422e-9c35-877e0cd89cfc"; // Stage clientId
  tenantId = "b9ad39bb-d4e9-4878-ae67-b3a5f56a5906"; // Stage tenantId
} else if (currentOrigin.includes("dev")) {
  // Dev Environment
  baseDomain = "https://candidateinterviewscheduler-dev.pwc.com/";
  clientId = "de4a41ef-5c38-422e-9c35-877e0cd89cfc"; // Dev clientId
  tenantId = "b9ad39bb-d4e9-4878-ae67-b3a5f56a5906"; // Dev tenantId
} else if (currentOrigin.includes("stg")) {
  // Stage Environment
  baseDomain = "https://candidateinterviewscheduler-stg.pwc.com/";
  clientId = "de4a41ef-5c38-422e-9c35-877e0cd89cfc"; // Stage clientId
  tenantId = "b9ad39bb-d4e9-4878-ae67-b3a5f56a5906"; // Stage tenantId
} else{
  baseDomain = "https://candidateinterviewscheduler.pwc.com/";
  clientId = "efb16ba4-9bd2-4886-92b9-2493c3b0d703"; // Stage clientId
  tenantId = "b762ea0c-3d77-4594-9516-3817ae155c30"; // Stage tenantId
}
  

// if (currentOrigin.includes("localhost")) {
//   clientId = "5a6ea4fa-311c-4ed5-bb9a-34bde4b7ac84"; // Dev
//   tenantId = "d4093791-9818-48dc-8880-35d134b8c79d";
// } else if (currentOrigin.includes("dev")) {
//   clientId = "5a6ea4fa-311c-4ed5-bb9a-34bde4b7ac84"; // Dev
//   tenantId = "d4093791-9818-48dc-8880-35d134b8c79d";
// } else if (currentOrigin.includes("stg")) {
//   clientId = "7addfae0-c849-4f78-bfcf-41e17b754fd1"; // Stage
//   tenantId = "831f8b7b-7bbc-4d34-a62b-7baf9792d24a";
// } else {
//   clientId = "prod-client-id";
//   tenantId = "prod-tenant-id";
// }

export const msalConfig: Configuration = {

  
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri:baseDomain,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "offline_access"],
};